import styled from 'styled-components';
import { screenBiggerThan, Screen } from '@client/styles/styled-components/breakpoints';

export const Wrapper = styled.span`
    flex: 1 1 auto;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    width: 100%;
    text-align: left;
    ${screenBiggerThan(Screen.mobile)} {
        margin-bottom: 12px;
    }
`;

export const NoCategorySublinePlaceholder = styled.div`
    height: 18px;
    ${screenBiggerThan(Screen.mobile)} {
        height: 33px;
    }
`;
